import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

import styles from "./UserDashboard.module.css";
import { UserContext } from "../../context/UserContext";
import { DataContext } from "../../context/DataContext";
import Button from "../../components/common/Button";

export default function UserDashboard() {
  const { t } = useTranslation(["profile", "personalityTypes"]);
  const navigate = useNavigate();
  const { userData } = useContext(UserContext);
  const { meetingsList } = useContext(DataContext);

  /* ================= Editorial (dinâmico) ================= */
  const [editorial] = useState({
    type: "Artigo sugerido",
    title: "Terapia de Aceitação e Compromisso (ACT) - um guia rápido",
    subtitle: "Perez e Hayes (2025)",
    link: "https://www.revistaperspectivas.org/perspectivas/article/view/1258/592",
  });

  if (!userData) {
    return <div>Carregando...</div>;
  }

  return (
    <div className={styles.container}>
      <div className={styles.grid}>
        {/* ================= LEFT COLUMN ================= */}
        <div className={styles.colLeft}>
          {/* ===== Encontros ===== */}
          <section className={styles.card}>
            <div className={styles.cardHeader}>
              <h3>Encontros</h3>
              <small className={styles.muted}>
                Espaço vivo de discussão clínica e formulação
              </small>
            </div>

            <div className={styles.meetingsList}>
              {meetingsList.length === 0 ? (
                <p className={styles.muted}>Nenhum encontro agendado.</p>
              ) : (
                meetingsList.map((m) => (
                  <div key={m.id} className={styles.meetingRow}>
                    <div>
                      <div className={styles.meetingTitle}>{m.title}</div>
                      {m.scheduleFor && (
                        <div className={styles.meetingTime}>
                          {new Date(m.scheduleFor).toLocaleDateString("pt-BR", {
                            weekday: "long",
                            day: "2-digit",
                            month: "2-digit",
                            year: "2-digit",
                            hour: "2-digit",
                            minute: "2-digit",
                          })}{" "}
                          • {m.proName || ""}
                        </div>
                      )}
                    </div>

                    <div className={styles.meetingActions}>
                      <Link
                        to={`/meeting/${m.id}`}
                        className={styles.openMeeting}
                      >
                        Ver detalhes
                      </Link>

                      {m.moderatorOnline && (
                        <a
                          onClick={() =>
                            window.open(
                              m.meetingUrl ||
                                `https://meet.jit.si/${m.jitsiRoomName}`,
                              "_blank",
                              "noopener,noreferrer"
                            )
                          }
                          className={styles.joinMeeting}
                        >
                          Entrar no encontro
                        </a>
                      )}
                    </div>
                  </div>
                ))
              )}
            </div>
          </section>

          {/* ===== Programas Clínicos ===== */}
          <h3>Programas Clínicos</h3>

          {/* ===== Grupo ===== */}
          <section className={styles.card}>
            <div className={styles.sideBySide}>
              <img
                src="/images/group-processes.jpg"
                alt="Grupo de Discussão em Terapia Baseada em Processos"
                style={{ width: "100%", borderRadius: "10px" }}
              />

              <div>
                <div className={styles.cardHeader}>
                  <h3>Grupo de Discussão em Terapia Baseada em Processos</h3>
                  <small className={styles.muted}>
                    Programa clínico longitudinal
                  </small>
                </div>

                <p className={styles.muted}>
                  Espaço contínuo de desenvolvimento do raciocínio clínico,
                  sustentado por encontros, formulação e reflexão compartilhada.
                </p>

                <div className={styles.meetingActions}>
                  <Link to="/about-group" className={styles.openMeeting}>
                    Conhecer a proposta
                  </Link>
                  <Button onClick={() => navigate("/group-enrollment")}>
                    Realizar Inscrição
                  </Button>
                </div>
              </div>
            </div>
          </section>

          {/* ===== Mini-curso ===== */}
          <section className={styles.card}>
            <div className={styles.sideBySide}>
              <img
                src="/images/act-course.jpg"
                alt="Mini-curso de ACT"
                style={{
                  width: "100%",
                  borderRadius: "10px",
                  opacity: 0.6,
                }}
              />

              <div>
                <div className={styles.cardHeader}>
                  <h3>Mini-curso: Terapia de Aceitação e Compromisso</h3>
                  <small className={styles.muted}>Em desenvolvimento</small>
                </div>

                <p className={styles.muted}>
                  Introdução conceitual à ACT com foco nos processos
                  psicológicos e sua aplicação clínica.
                </p>

                <button className={styles.secondaryBtn} disabled>
                  Em breve
                </button>
              </div>
            </div>
          </section>
        </div>

        {/* ================= RIGHT COLUMN ================= */}
        <div className={styles.colRight}>
          {/* ===== Enquadramento ===== */}
          <section className={styles.card}>
            <h3>Como este ambiente foi pensado</h3>
            <ul className={styles.list}>
              <li>
                <strong>Encontros:</strong> discussão clínica viva
              </li>
              <li>
                <strong>Formulação:</strong> organização do raciocínio
              </li>
              <li>
                <strong>Escalas:</strong> apoio reflexivo
              </li>
              <li>
                <strong>Metáforas:</strong> ampliação de repertório
              </li>
            </ul>
          </section>

          {/* ===== Editorial Dinâmico ===== */}
          <section className={styles.card}>
            <small className={styles.muted}>{editorial.type}</small>
            <h3>{editorial.title}</h3>
            <p className={styles.muted}>{editorial.subtitle}</p>

            {editorial.link && (
              <a
                href={editorial.link}
                target="_blank"
                rel="noreferrer"
                className={styles.openMeeting}
              >
                Acessar leitura
              </a>
            )}
          </section>
        </div>
      </div>
    </div>
  );
}
